import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import './AdminTraining.css';

function AdminTraining() {
  const [trainings, setTrainings] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState({});
  const [denyReasons, setDenyReasons] = useState({});

  useEffect(() => {
    const fetchPendingTrainings = async () => {
      try {
        const playerId = localStorage.getItem('playerId');
        if (!playerId) throw new Error('Please log in');

        const res = await fetch(`${API_BASE_URL}/training-admin-pending`, {
          headers: { 'player-id': playerId }
        });
        if (!res.ok) throw new Error('Failed to fetch pending trainings');

        const data = await res.json();
        setTrainings(data);
        setLoading(false);
      } catch (error) {
        setMessage('Error: ' + error.message);
        setLoading(false);
      }
    };
    fetchPendingTrainings();
  }, []);

  const handleProcess = async (trainingId, status) => {
    try {
      setProcessing(prev => ({ ...prev, [trainingId]: true }));
      const playerId = localStorage.getItem('playerId');
      const body = { status };
      if (status === 'Rejected') {
        const reason = denyReasons[trainingId];
        if (!reason) {
          setMessage('Error: Deny reason required for rejection');
          return;
        }
        body.denyReason = reason;
      }

      const res = await fetch(`${API_BASE_URL}/training-process/${trainingId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'player-id': playerId
        },
        body: JSON.stringify(body)
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Processing failed');

      setTrainings(prev => prev.filter(t => t._id !== trainingId));
      setMessage(`Training ${status.toLowerCase()} successfully`);
    } catch (error) {
      setMessage('Error: ' + error.message);
    } finally {
      setProcessing(prev => ({ ...prev, [trainingId]: false }));
    }
  };

  const handleDenyReasonChange = (trainingId, value) => {
    setDenyReasons(prev => ({ ...prev, [trainingId]: value }));
  };

  if (loading) return <div className="training-admin-container"><p>Loading...</p></div>;

  return (
    <div className="training-admin-container">
      {message && (
        <div className={`message ${message.includes('Error') ? 'error' : 'success'}`}>
          {message}
        </div>
      )}
      <h2>Pending Training Submissions</h2>
      {trainings.length === 0 ? (
        <p>No pending training submissions.</p>
      ) : (
        <table className="training-table">
          <thead>
            <tr>
              <th>Dog</th>
              <th>Staff</th>
              <th>Player</th>
              <th>Artwork</th>
              <th>Submission Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {trainings.map(training => (
              <tr key={training._id}>
                <td>{training.dogId?.registeredName || 'Unknown'}</td>
                <td>{training.staffId?.staffName || 'Unknown'}</td>
                <td>{training.playerId?.username || 'Unknown'}</td>
                <td>
                  <a href={training.artworkUrl} target="_blank" rel="noopener noreferrer">
                    View Artwork
                  </a>
                </td>
                <td>{new Date(training.submissionDate).toLocaleDateString()}</td>
                <td>
                  <button
                    className="action-button"
                    onClick={() => handleProcess(training._id, 'Approved')}
                    disabled={processing[training._id]}
                  >
                    {processing[training._id] ? 'Processing...' : 'Approve'}
                  </button>
                  <input
                    type="text"
                    className="text-input"
                    placeholder="Deny reason"
                    value={denyReasons[training._id] || ''}
                    onChange={(e) => handleDenyReasonChange(training._id, e.target.value)}
                    style={{ margin: '0 10px' }}
                  />
                  <button
                    className="action-button remove-button"
                    onClick={() => handleProcess(training._id, 'Rejected')}
                    disabled={processing[training._id] || !denyReasons[training._id]}
                  >
                    {processing[training._id] ? 'Processing...' : 'Reject'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AdminTraining;